import {getManagerHeader} from "../Login/functions";
import axios from "axios";
import {baseCmsApiUrl} from "../../assets/Constants";
import {base64DecodeUnicode, listToTree} from "../../assets/functions";

export const getAllTowns = async () => {
    const headers = getManagerHeader();

    return axios.get(baseCmsApiUrl + 'towns', {headers})
        .then((response) => {
            // console.log(response)
            // console.log(base64DecodeUnicode(response.statusText))
            return response.data;
        })
        .catch((e) => {
            console.error(e)
            console.log(base64DecodeUnicode(e.response.statusText))
            console.log(e.response.data)
        })
}
export const getAreaBlocks = (townsObject) => {
    const areaBlocks = [];
    for (let i = 0; i < townsObject.length; i++)
        if (!areaBlocks.includes(townsObject[i].areaBlock))
            areaBlocks.push(townsObject[i].areaBlock)

    return areaBlocks;
}

export const getAllTownObject = async () => {
    const allTowns = await getAllTowns();
    const allTownsObject = allTowns.map((town) => {
        return {
            id: town.id,
            value: town.id,
            label: town.name,
            type: town.type,
            areaBlock: town.areaBlock,
            parentId: town.areaBlock,
        }
    })
    return allTownsObject;
}
export const getAreaBlocksObject = (allTownsObject) => {
    const areaBlocks = getAreaBlocks(allTownsObject);

    const areaBlocksObject = areaBlocks.map((areaBlock) => {
        return {
            id: areaBlock,
            label: "بلاک " + areaBlock,
            value: areaBlock,
            parentId: -1,
        }
    })
    return areaBlocksObject;
}
export const getAllTownsDividedByAreaBlock = async (removedArea = {
    isAllIsland: "FALSE",
    includeAreaBlock: [],
    excludeAreaBlock: [],
    includeTown: [],
    excludeTown: [],
}) => {
    const allTownsObject = await getAllTownObject();
    const areaBlocks = getAreaBlocksObject(allTownsObject);

    const areaBlockAndTown = [{
        id: -1,
        label: "کل جزیره",
        value: "ALL_ISLAND"
    }, ...allTownsObject, ...areaBlocks];
    return areaBlockAndTown;
}
export const getFilteredAllTownsDividedByAreaBlock = ( allArea , removedArea = {
    isAllIsland: "FALSE",
    includeAreaBlock: [],
    excludeAreaBlock: [],
    includeTown: [],
    excludeTown: [],
}) => {
    if (removedArea.isAllIsland == "TRUE")
        return [];
    const filteredAreaBlockAndTown = allArea.filter((area) => {
        if ((removedArea.includeTown.includes(area.value) || removedArea.includeAreaBlock.includes(area.value) ||
            (area.areaBlock && removedArea.includeAreaBlock.includes(area.areaBlock))
        )){
            return null;
        }
        return area;
    })

    return filteredAreaBlockAndTown;
}



export const convertAreaObjectToArray = (area) => {
    let areaArray = [];
    if (area.isAllIsland == "TRUE") {
        areaArray.push(-1);
        return areaArray;
    }
    areaArray = [...area.includeAreaBlock, ...area.includeTown];
    return areaArray;

}

export const getUnionAreaObject = (sending, startIndex = 0, endIndex = sending.length - 1) => {
    const area = {
        isAllIsland: "FALSE",
        includeAreaBlock: [],
        excludeAreaBlock: [],
        includeTown: [],
        excludeTown: [],
    }

    for (let i = 0; i < sending.length && i < endIndex ; i++) {
        if (sending[i].area.isAllIsland == "TRUE") {
            area.isAllIsland = "TRUE";
            area.includeAreaBlock = [];
            area.excludeAreaBlock = [];
            area.includeTown = [];
            area.excludeTown = [];
            return area;
        }
        area.includeAreaBlock = [...area.includeAreaBlock , ...sending[i].area.includeAreaBlock];
        area.includeTown = [...area.includeTown , ...sending[i].area.includeTown];
    }

    return area;

}